var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-menu-list",
    [
      _c("b-menu-item", {
        attrs: {
          to: { name: "dashboard" },
          tag: "router-link",
          active: _vm.activeItem.dashboard,
          icon: "view-dashboard-variant-outline",
          label: _vm.$t("menu.dashboard"),
        },
      }),
      _c(
        "b-menu-item",
        {
          attrs: {
            expanded: _vm.activeGroup.lists,
            active: _vm.activeGroup.lists,
            "data-cy": "lists",
            icon: "format-list-bulleted-square",
            label: _vm.$t("globals.terms.lists"),
          },
          on: { "update:active": (state) => _vm.toggleGroup("lists", state) },
        },
        [
          _c("b-menu-item", {
            attrs: {
              to: { name: "lists" },
              tag: "router-link",
              active: _vm.activeItem.lists,
              "data-cy": "all-lists",
              icon: "format-list-bulleted-square",
              label: _vm.$t("menu.allLists"),
            },
          }),
          _c("b-menu-item", {
            staticClass: "forms",
            attrs: {
              to: { name: "forms" },
              tag: "router-link",
              active: _vm.activeItem.forms,
              icon: "newspaper-variant-outline",
              label: _vm.$t("menu.forms"),
            },
          }),
        ],
        1
      ),
      _c(
        "b-menu-item",
        {
          attrs: {
            expanded: _vm.activeGroup.subscribers,
            active: _vm.activeGroup.subscribers,
            "data-cy": "subscribers",
            icon: "account-multiple",
            label: _vm.$t("globals.terms.subscribers"),
          },
          on: {
            "update:active": (state) => _vm.toggleGroup("subscribers", state),
          },
        },
        [
          _c("b-menu-item", {
            attrs: {
              to: { name: "subscribers" },
              tag: "router-link",
              active: _vm.activeItem.subscribers,
              "data-cy": "all-subscribers",
              icon: "account-multiple",
              label: _vm.$t("menu.allSubscribers"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "import" },
              tag: "router-link",
              active: _vm.activeItem.import,
              "data-cy": "import",
              icon: "file-upload-outline",
              label: _vm.$t("menu.import"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "bounces" },
              tag: "router-link",
              active: _vm.activeItem.bounces,
              "data-cy": "bounces",
              icon: "email-bounce",
              label: _vm.$t("globals.terms.bounces"),
            },
          }),
        ],
        1
      ),
      _c(
        "b-menu-item",
        {
          attrs: {
            expanded: _vm.activeGroup.campaigns,
            active: _vm.activeGroup.campaigns,
            "data-cy": "campaigns",
            icon: "rocket-launch-outline",
            label: _vm.$t("globals.terms.campaigns"),
          },
          on: {
            "update:active": (state) => _vm.toggleGroup("campaigns", state),
          },
        },
        [
          _c("b-menu-item", {
            attrs: {
              to: { name: "campaigns" },
              tag: "router-link",
              active: _vm.activeItem.campaigns,
              "data-cy": "all-campaigns",
              icon: "rocket-launch-outline",
              label: _vm.$t("menu.allCampaigns"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "campaign", params: { id: "new" } },
              tag: "router-link",
              active: _vm.activeItem.campaign,
              "data-cy": "new-campaign",
              icon: "plus",
              label: _vm.$t("menu.newCampaign"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "media" },
              tag: "router-link",
              active: _vm.activeItem.media,
              "data-cy": "media",
              icon: "image-outline",
              label: _vm.$t("menu.media"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "templates" },
              tag: "router-link",
              active: _vm.activeItem.templates,
              "data-cy": "templates",
              icon: "file-image-outline",
              label: _vm.$t("globals.terms.templates"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "campaignAnalytics" },
              tag: "router-link",
              active: _vm.activeItem.campaignAnalytics,
              "data-cy": "analytics",
              icon: "chart-bar",
              label: _vm.$t("globals.terms.analytics"),
            },
          }),
        ],
        1
      ),
      _c(
        "b-menu-item",
        {
          attrs: {
            expanded: _vm.activeGroup.settings,
            active: _vm.activeGroup.settings,
            "data-cy": "settings",
            icon: "cog-outline",
            label: _vm.$t("menu.settings"),
          },
          on: {
            "update:active": (state) => _vm.toggleGroup("settings", state),
          },
        },
        [
          _c("b-menu-item", {
            attrs: {
              to: { name: "settings" },
              tag: "router-link",
              active: _vm.activeItem.settings,
              "data-cy": "all-settings",
              icon: "cog-outline",
              label: _vm.$t("menu.settings"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "maintenance" },
              tag: "router-link",
              active: _vm.activeItem.maintenance,
              "data-cy": "maintenance",
              icon: "wrench-outline",
              label: _vm.$t("menu.maintenance"),
            },
          }),
          _c("b-menu-item", {
            attrs: {
              to: { name: "logs" },
              tag: "router-link",
              active: _vm.activeItem.logs,
              "data-cy": "logs",
              icon: "newspaper-variant-outline",
              label: _vm.$t("menu.logs"),
            },
          }),
        ],
        1
      ),
      _vm.isMobile
        ? _c("b-menu-item", {
            attrs: { icon: "logout-variant", label: _vm.$t("users.logout") },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.doLogout.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }